export const sort = [
  {
    label: "ID",
    name: "id",
    style: { width: 130 },
  },
  { label: "Nazwa", name: "name" },
];

export const filters = [
  {
    type: "input",
    name: "name",
    sort_id: "name",
    search_type: "matches",
  },
];
